import { computed } from 'vue';
import { useRoute, type LocationQuery } from 'vue-router';

export const isParamString = (query: LocationQuery[string]): query is string => {
    return !!query && !Array.isArray(query);
};

export const useRouteMatch = (routeToMatch: string) => {
    const route = useRoute();
    return computed(() => route.path.startsWith(routeToMatch));
};
